/* Ishifo — Video shop. Reads everything from the section's data-* attributes. */
(function () {
  if (customElements.get('ishifo-video-shop')) return;

  /* Must stay in step with the 1320px block in the stylesheet. */
  var WIDE = '(min-width: 1320px)';

  class IshifoVideoShop extends HTMLElement {
    connectedCallback() {
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      if (!this.panels.length) return;

      this.activeCard = this.querySelector('[data-slot="active"]');
      this.nextCard = this.querySelector('[data-slot="next"]');
      this.thirdCard = this.querySelector('[data-slot="third"]');
      this.video = this.querySelector('[data-video]');
      this.activePoster = this.querySelector('[data-active-poster]');
      this.nextPoster = this.querySelector('[data-next-poster]');
      this.thirdPoster = this.querySelector('[data-third-poster]');
      this.bar = this.querySelector('[data-bar]');
      this.counters = Array.prototype.slice.call(this.querySelectorAll('[data-counter]'));

      /* Autoplay only works on a muted, inline video. Set the properties too,
         not just the attributes, so every browser (iOS Safari especially)
         treats it as muted from the very first play() call. */
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.blocked = false;

      /* With under 3 clips the index wraps and the third card would duplicate
         the playing one. Drop it; every guard below copes with it missing. */
      if (this.thirdCard && this.panels.length < 3) {
        this.thirdCard.remove();
        this.thirdCard = null;
        this.thirdPoster = null;
      }

      this.cardUi = {
        active: this.cardParts(this.activeCard),
        next: this.cardParts(this.nextCard),
        third: this.thirdCard ? this.cardParts(this.thirdCard) : null
      };

      this.i = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 9000;
      this.saveData = !!(navigator.connection && navigator.connection.saveData);
      this.inView = false;

      /* Backstop only — the handover runs off the real animationend. */
      this.outMs = 380;
      this.busy = false;

      var self = this;
      this.nextCard.addEventListener('click', function (e) {
        if (self.swipedRecently()) { e.preventDefault(); return; }
        if (e.target.closest && e.target.closest('a')) return;
        self.go(1);
      });
      this.nextCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.go(1); }
      });

      /* Tap the big card to play if the browser blocked autoplay
         (iPhone Low Power Mode, some Android data savers). */
      this.activeCard.addEventListener('click', function (e) {
        if (self.swipedRecently()) return;
        if (e.target.closest && e.target.closest('a')) return;
        self.tryPlay();
      });

      /* First touch or click anywhere on the page also retries a blocked play. */
      this.kick = function () {
        if (self.blocked && self.inView) self.tryPlay();
      };
      document.addEventListener('touchstart', this.kick, { passive: true });
      document.addEventListener('click', this.kick);

      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(-1); });
      if (next) next.addEventListener('click', function () { self.go(1); });

      this.video.addEventListener('ended', function () { self.go(1); });
      this.video.addEventListener('playing', this.onPlaying.bind(this));

      /* Crossing the breakpoint reveals an unpainted third card. fillThird(),
         not paint() — a repaint would reload and restart the clip. */
      this.wideMq = window.matchMedia(WIDE);
      this.onWide = function () { self.fillThird(); };
      if (this.wideMq.addEventListener) this.wideMq.addEventListener('change', this.onWide);
      else if (this.wideMq.addListener) this.wideMq.addListener(this.onWide);

      this.bindSizes();
      this.bindSwipe();

      /* ISHIFO SPEED (27-Sep): card ki photos (~76KB) page khulte hi aa jaati
         thin, jabki ye section homepage par kaafi neeche hai — slow net par ye
         upar ke Best Sellers cards se bandwidth chheen leti thin. Ab photos tab
         lagti hain jab section screen se lagbhag ek screen door ho. Naam, price,
         video — sab pehle jaisa. */
      this.postersOn = !('IntersectionObserver' in window);
      if (!this.postersOn) {
        this.posterIo = new IntersectionObserver(function (entries) {
          for (var k = 0; k < entries.length; k++) {
            if (entries[k].isIntersecting) {
              self.posterIo.disconnect();
              self.postersOn = true;
              self.setPosters();
              self.fillThird();
              return;
            }
          }
        }, { rootMargin: '100% 0px' });
        this.posterIo.observe(this);
      }
      this.paint(0);

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            self.inView = entry.isIntersecting;
            if (entry.isIntersecting) { self.start(); } else { self.stop(); }
          });
        }, { rootMargin: '200px 0px' });
        this.io.observe(this);
      } else {
        this.inView = true;
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.posterIo) this.posterIo.disconnect();
      if (this.kick) {
        document.removeEventListener('touchstart', this.kick);
        document.removeEventListener('click', this.kick);
      }
      if (this.wideMq && this.onWide) {
        if (this.wideMq.removeEventListener) this.wideMq.removeEventListener('change', this.onWide);
        else if (this.wideMq.removeListener) this.wideMq.removeListener(this.onWide);
      }
    }

    tryPlay() {
      var v = this.video;
      if (!v || !v.firstChild || !v.paused) return;
      var self = this;
      v.muted = true;
      var p = v.play();
      if (p && p.then) {
        p.then(function () { self.blocked = false; }).catch(function () { self.blocked = true; });
      }
    }

    cardParts(card) {
      return {
        link: card.querySelector('[data-ov-link]'),
        title: card.querySelector('[data-ov-title]'),
        price: card.querySelector('[data-ov-price]'),
        shop: card.querySelector('[data-shop]'),
        badge: card.querySelector('[data-badge]')
      };
    }

    fillCard(ui, d) {
      if (!ui) return;
      if (ui.link) ui.link.href = d.url;
      if (ui.shop) ui.shop.href = d.url;
      if (ui.title) ui.title.textContent = d.title;
      if (ui.price) ui.price.innerHTML = d.compare ? d.price + ' <s>' + d.compare + '</s>' : d.price;
      if (ui.badge) {
        ui.badge.textContent = d.off || '';
        ui.badge.hidden = !d.off;
      }
    }

    /* Touch swipe. Axis-locked: the first few pixels decide whether this
       gesture belongs to the carousel or to the page. */
    bindSwipe() {
      var self = this;
      var targets = [this.querySelector('.ivs__cards'), this.querySelector('.ivs__detail')];
      var cards = targets[0];
      if (cards) cards.style.touchAction = 'pan-y';

      var x0 = 0, y0 = 0, t0 = 0, lock = 0, active = false;
      var THRESH = 8;     /* px before the axis is decided */
      var MIN = 45;       /* px of travel that counts as a swipe */
      var FAST = 12;      /* px on a flick under 250ms */

      function start(e) {
        if (e.touches.length !== 1) { active = false; return; }
        /* let the size chips, arrows and the add-to-cart form keep their taps */
        if (e.target.closest && e.target.closest('button, input, select, textarea, label')) {
          active = false;
          return;
        }
        active = true;
        lock = 0;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        t0 = Date.now();
      }

      function move(e) {
        if (!active || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;

        if (!lock) {
          if (Math.abs(dx) < THRESH && Math.abs(dy) < THRESH) return;
          lock = Math.abs(dx) > Math.abs(dy) ? 1 : -1;
        }
        if (lock === 1 && e.cancelable) e.preventDefault();
      }

      function end(e) {
        if (!active) return;
        active = false;
        if (lock !== 1) return;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;
        var dx = touch.clientX - x0;
        var quick = (Date.now() - t0) < 250;
        if (Math.abs(dx) < (quick ? FAST : MIN)) return;
        self.swipeAt = Date.now();
        self.go(dx < 0 ? 1 : -1);
      }

      targets.forEach(function (el) {
        if (!el) return;
        el.addEventListener('touchstart', start, { passive: true });
        el.addEventListener('touchmove', move, { passive: false });
        el.addEventListener('touchend', end, { passive: true });
        el.addEventListener('touchcancel', function () { active = false; }, { passive: true });
      });

      /* a swipe that ends on a link still fires click in some browsers */
      this.addEventListener('click', function (e) {
        if (self.swipedRecently()) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    swipedRecently() {
      return !!this.swipeAt && (Date.now() - this.swipeAt) < 500;
    }

    bindSizes() {
      var self = this;
      this.panels.forEach(function (panel) {
        var input = panel.querySelector('[data-variant-input]');
        var price = panel.querySelector('.ivs__price');
        var compare = panel.querySelector('.ivs__compare');
        var atcPrice = panel.querySelector('[data-atc-price]');
        var sizeValue = panel.querySelector('[data-size-value]');
        var chips = panel.querySelectorAll('.ivs__size');

        Array.prototype.forEach.call(chips, function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            Array.prototype.forEach.call(chips, function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');

            var p = btn.getAttribute('data-price');
            var c = btn.getAttribute('data-compare');
            var o = btn.getAttribute('data-off');

            if (input) input.value = btn.getAttribute('data-variant');
            if (price) price.textContent = p;
            if (atcPrice) atcPrice.textContent = p;
            if (sizeValue) sizeValue.textContent = btn.getAttribute('data-value');
            if (compare) {
              compare.textContent = c || '';
              compare.style.display = c ? '' : 'none';
            }

            panel.setAttribute('data-price', p);
            panel.setAttribute('data-compare', c || '');
            panel.setAttribute('data-off', o || '');
            if (self.panels[self.i] === panel) self.fillCard(self.cardUi.active, panel.dataset);
          });
        });
      });
    }

    data(i) { return this.panels[(i + this.panels.length) % this.panels.length].dataset; }

    small() { return window.matchMedia('(max-width: 989px)').matches; }

    wide() { return this.wideMq ? this.wideMq.matches : false; }

    stillFor(d) {
      return this.small() ? d.imageSmall : d.image;
    }

    fillThird() {
      if (!this.thirdCard || !this.wide()) return;
      var t = this.data(this.i + 2);
      if (this.postersOn) this.thirdPoster.src = this.stillFor(t);
      this.fillCard(this.cardUi.third, t);
    }

    setPosters() {
      if (!this.postersOn) return;
      this.activePoster.src = this.stillFor(this.data(this.i));
      this.nextPoster.src = this.stillFor(this.data(this.i + 1));
    }

    /* Warm the next beat's stills while the old card is still leaving. */
    preload(i) {
      var self = this;
      var list = [this.data(i), this.data(i + 1)];
      if (this.thirdCard && this.wide()) list.push(this.data(i + 2));
      list.forEach(function (d) {
        var src = self.stillFor(d);
        if (!src) return;
        var img = new Image();
        img.src = src;
        if (img.decode) img.decode().catch(function () {});
      });
    }

    paint(dir) {
      var d = this.data(this.i);
      var n = this.data(this.i + 1);
      var self = this;

      this.setPosters();
      this.fillCard(this.cardUi.active, d);
      this.fillCard(this.cardUi.next, n);
      this.fillThird();

      this.panels.forEach(function (p, k) {
        p.classList.toggle('is-active', k === self.i);
      });

      var label = ('0' + (this.i + 1)).slice(-2) + ' / ' + ('0' + this.panels.length).slice(-2);
      this.counters.forEach(function (c) { c.textContent = label; });

      if (dir !== 0) {
        var cls = dir > 0 ? 'is-in-next' : 'is-in-prev';
        this.replay(this.activeCard, cls);
        this.replay(this.nextCard, cls);
        this.replay(this.thirdCard, cls);
        this.replay(this.panels[this.i], 'is-in');
      }

      this.loadVideo(d);
    }

    clear(el) {
      if (!el) return;
      el.classList.remove('is-in-next', 'is-in-prev', 'is-in', 'is-out-next', 'is-out-prev', 'is-out');
    }

    replay(el, cls) {
      if (!el) return;
      this.clear(el);
      void el.offsetWidth;
      el.classList.add(cls);
    }

    loadVideo(d) {
      var v = this.video;
      var self = this;
      this.activeCard.classList.remove('is-playing');
      v.pause();
      v.removeAttribute('src');
      while (v.firstChild) v.removeChild(v.firstChild);
      v.load();

      this.resetBar();
      if (!this.inView || this.saveData) return;

      /* MP4 first. Shopify always makes MP4 renditions and every browser
         plays them. HLS (.m3u8) is only a fallback: several Android and
         desktop Chrome builds claim they can play it, pick it, and then
         never start, which left the card stuck on its photo. */
      var mp4 = this.small() ? (d.mp4Small || d.mp4) : (d.mp4 || d.mp4Small);
      if (mp4) {
        var s2 = document.createElement('source');
        s2.src = mp4;
        s2.type = 'video/mp4';
        v.appendChild(s2);
      } else if (d.hls) {
        var s1 = document.createElement('source');
        s1.src = d.hls;
        s1.type = 'application/x-mpegURL';
        v.appendChild(s1);
      }
      if (!v.firstChild) return;

      v.muted = true;
      v.load();
      var p = v.play();
      if (p && p.then) {
        p.then(function () { self.blocked = false; }).catch(function () { self.blocked = true; });
      }
      this.armFallback();
    }

    onPlaying() {
      this.blocked = false;
      this.activeCard.classList.add('is-playing');
      var ms = (this.video.duration && isFinite(this.video.duration)) ? this.video.duration * 1000 : this.interval;
      this.runBar(ms);
      this.armFallback(ms + 1200);
    }

    resetBar() {
      this.bar.style.transition = 'none';
      this.bar.style.width = '0%';
      void this.bar.offsetWidth;
    }

    runBar(ms) {
      this.resetBar();
      this.bar.style.transition = 'width ' + ms + 'ms linear';
      this.bar.style.width = '100%';
    }

    /* One clip has nowhere to advance to — go() would just reload it forever. */
    armFallback(ms) {
      clearTimeout(this.timer);
      if (this.panels.length < 2) return;
      var self = this;
      this.timer = setTimeout(function () { self.go(1); }, ms || this.interval);
    }

    start() {
      this.loadVideo(this.data(this.i));
      if (this.saveData) { this.runBar(this.interval); this.armFallback(); }
    }

    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.outTimer);
      this.busy = false;
      if (this.video) this.video.pause();
    }

    /* One swap, two beats, mirrored in both directions. busy blocks a second
       swap mid-flight so fast clicks cannot desync the two beats. */
    go(dir) {
      if (!dir) { this.paint(0); return; }
      if (this.busy || this.panels.length < 2) return;
      this.busy = true;
      clearTimeout(this.timer);

      var self = this;
      var panel = this.panels[this.i];
      var target = (this.i + dir + this.panels.length) % this.panels.length;
      var exitEl;

      /* the stylesheet reads this to mirror the detail panel's slide */
      this.dataset.dir = dir > 0 ? 'next' : 'prev';

      this.preload(target);

      this.activeCard.classList.remove('is-playing');

      if (dir > 0) {
        this.replay(this.activeCard, 'is-out-next');
        this.clear(this.nextCard);
        this.clear(this.thirdCard);
        exitEl = this.activeCard;
      } else {
        this.clear(this.activeCard);
        this.clear(this.nextCard);
        this.replay(this.thirdCard, 'is-out-prev');
        exitEl = this.thirdCard;
      }

      this.replay(panel, 'is-out');
      if (!exitEl) exitEl = panel;

      var done = false;
      var finish = function (e) {
        if (done) return;
        if (e && e.target !== exitEl) return;
        done = true;
        exitEl.removeEventListener('animationend', finish);
        clearTimeout(self.outTimer);
        if (panel) panel.classList.remove('is-out');
        self.busy = false;
        self.i = target;
        self.paint(dir);
      };

      exitEl.addEventListener('animationend', finish);
      clearTimeout(this.outTimer);
      this.outTimer = setTimeout(function () { finish(); }, this.outMs + 150);
    }
  }

  customElements.define('ishifo-video-shop', IshifoVideoShop);
})();
